import { Pagination } from 'antd';
import { type MouseEvent, useState } from 'react';
import { css } from 'styled-components';

import { CenterFlex, Divider, Flex, VFlex } from '@/components/base';
import Spinner from '@/components/Common/Spinner';
import List from '@/components/List/List';
import { MainText } from '@/components/Typography/NamedTypo';

import TopListItem from './TopListItem';

type ItemProps = DataBucketT & {
  name?: string;
  aliasList?: string[];
};

type Props = {
  data?: ItemProps[];
  isLoading: boolean;
  onClickItem: (e: MouseEvent, bucket: ItemProps) => void;
};

const GridTopList = (props: Props) => {
  const [page, setPage] = useState(0);
  const currentData = props.data?.slice(page * 10, (page + 1) * 10) || [];

  const largestCount =
    props.data?.reduce((acc, curr) => {
      return Math.max(acc, curr.count);
    }, 0) || 0;

  return (
    <VFlex g={24}>
      <List
        data={currentData}
        isLoading={props.isLoading}
        placeholder={{
          node: (
            <CenterFlex
              css={css`
                grid-column: 1 / span 2;
                grid-row: 1 / span 5;
                min-height: 250px;
              `}
            >
              <MainText dim>No data</MainText>
            </CenterFlex>
          ),
        }}
        loader={
          <CenterFlex
            css={css`
              grid-column: 1 / span 2;
              grid-row: 1 / span 5;
              min-height: 250px;
            `}
          >
            <Spinner />
          </CenterFlex>
        }
        className="w-full grid grid-flow-col grid-cols-2 grid-rows-5 gap-x-8 gap-y-1"
        render={(boundary, index) => (
          <VFlex g={4} key={`${boundary.bucket}-${index}`}>
            <TopListItem
              name={boundary.name || boundary.bucket}
              count={boundary.count}
              max={largestCount}
              onClick={(e) => props.onClickItem(e, boundary)}
            />
            {(index + 1) % 5 !== 0 && <Divider />}
          </VFlex>
        )}
      />
      <Flex>
        <Pagination
          total={props.data?.length || 0}
          current={page + 1}
          pageSize={10}
          onChange={(page) => setPage(page - 1)}
          showTotal={(total) => `Total ${total} items`}
        />
      </Flex>
    </VFlex>
  );
};

export default GridTopList;
